import fancyBox from './modules/fancybox';

document.addEventListener('DOMContentLoaded', function () {

	fancyBox.init();

}, false);